export const termsCatalog: {
  term: string;
  explanation: string;
  value: string;
}[] = [
  {
    term: 'Academic Progress Rate (APR)',
    explanation:
      'A student that returns in second Fall with 2.0 GPA and higher.',
    value: 'apr',
  },

  {
    term: 'Admit Type',
    explanation:
      'Classified as first time in college (FTIC), graduates, transfers (Transfer From Florida Colege System (FCS) or Other Undergraduate Transfer), or GRIT (pathway) at time of admission.',
    value: 'admit-type',
  },
  {
    term: 'Associate Degree',
    explanation:
      'Classified as Associated in Arts (AA) or Associated in Science (AS). Only applies to transfer students',
    value: 'associate-degree',
  },
  {
    term: 'At-Risk',
    explanation:
      'Refers to a student who has a high probability of failing a class or dropping out of school.',
    value: 'at-risk',
  },
  {
    term: 'Canvas Risk',
    explanation:
      'The performance level on a scale of 0 to 100 for a student in a given course. (NA: Not Available; Fail: 0 to less than 60; Risk: 60 to less than 70; Okay: 70 and above)',
    value: 'at-risk',
  },
  {
    term: 'Cohort',
    explanation: 'Group of students that enters UWF every year.',
    value: 'cohort',
  },
  {
    term: 'College',
    explanation:
      'Refers to the five academic units at UWF. (Example: College of Science and Engineering, College of Health, College of Business, College of Arts, Social Sciences and Humanities and School of Education)',
    value: 'college',
  },
  {
    term: 'Continuing Student',
    explanation:
      'Students admit type status after first semester at UWF. (Example: Continuing FTIC, Continuing Transfers)',
    value: 'continuing-student',
  },
  {
    term: 'Course Level',
    explanation:
      'Refers to the numerical value of the different course codes. For example: Undergraduate (1000, 2000, 3000, 4000); Graduates (5000, 6000 +)',
    value: 'course-level',
  },
  {
    term: 'Critical Course Score',
    explanation:
      'A course score relative to other courses taken in each semester (Scale: 0-1). Higher scores between courses represent better impact on graduation time.',
    value: 'critical-course-score',
  },
  {
    term: 'Dropout Risk',
    explanation:
      'Refers to the likelihood of a student dropping out from school. (High: Below 0.6; Medium: 0.6 to less than 0.8; Low: 0.8 to 1)',
    value: 'at-risk',
  },
  {
    term: 'Enrollment',
    explanation: 'Count of students who register for a given semester.',
    value: 'enrollment',
  },
  {
    term: 'Full/Part-Time Indicator',
    explanation:
      'Full-Time: Taking 12 or more hours. Part-Time: Taking less than 12 hours.',
    value: 'full-part-time-ind',
  },
  {
    term: 'Fund Type/Code',
    explanation:
      'Classify funds according to specified donors or sponsors. (ACEX, ARGO, FDUL, FDUG, FLUT, FLMS, BOIG, BIRD, ETC…)',
    value: 'fund-type-code',
  },
  {
    term: 'Fund Source/Donors',
    explanation: 'Institutional, Federal, State, Private',
    value: 'fund-source-donors',
  },
  {
    term: 'Financial Aid (FA)',
    explanation: 'Money to help students pay for college.',
    value: 'financial-aid',
  },
  {
    term: 'First Time in College (FTIC)',
    explanation:
      'Students who have earned a standard high school diploma from a Florida public or regionally accredited high school or its equivalent and who have earned fewer than 12 semester hours of transferable college credit.',
    value: 'ftic',
  },
  {
    term: 'MaxTerm SEP',
    explanation: 'The latest term that a student should graduate.',
    value: 'max-sep',
  },
  {
    term: 'UWF Grade Point Average (GPA)',
    explanation:
      'Calculated as the total number of quality points (grade points multiplied by course semester hour credits) divided by the total number of semester hours for which letter grades are received.',
    value: 'uwf-gpa',
  },
  {
    term: 'Pell Grant',
    explanation: 'A need-based financial aid for students to pay for college.',
    value: 'pell-grant',
  },
  {
    term: 'Post Bachelor',
    explanation:
      'A credential you can pursue after finishing your undergraduate degree.',
    value: 'post-bachelor',
  },
  {
    term: 'Prior Hours',
    explanation:
      'Credit hours earned (including dual enrolled hours) prior to enrolling at UWF as an FTIC student.',
    value: 'prior-hours',
  },
  {
    term: 'Pre-college APR Risk',
    explanation:
      'Refers to the probability of a student making APR. (High: Below 0.7, Moderate 2: 0.7 to less than 0.8, Moderate 1: 0.8 to less than 0.9, Low: Above 0.9)',
    value: 'apr',
  },
  {
    term: 'Prerequisite',
    explanation:
      'A course or other requirement that a student must have taken prior to enrolling in a specific course or program.',
    value: 'prerequisite',
  },

  {
    term: 'Program',
    explanation:
      'An area of study with a specified collection of courses that must be completed to earn a particular degree or certificate. (Example: Computer Science, Psychology and etc)',
    value: 'program',
  },
  {
    term: 'Recommender Type',
    explanation:
      'Different ways to recommend courses. Such as Popular [Most Course Enrollment], Easy [Highest Average Pass Rate] and Good [Mix of Easy/Popular].',
    value: 'recommender-type',
  },
  {
    term: 'Retention',
    explanation: 'Returning for second Fall with any GPA.',
    value: 'retention',
  },
  {
    term: 'Risk Color Coding',
    explanation:
      'Color coding for different risk categories. [Canvas Report: Green = Okay; Yellow = Risk; Red = Fail; Black = Not Available;] [Dropout Risk: Green = Low; Orange = Medium; Red = High] ',
    value: 'risk-color-coding',
  },
  {
    term: 'Target Course',
    explanation: 'A course for which a prediction is being made.',
    value: 'target-course',
  },
  {
    term: 'Target Semester',
    explanation: 'A semester for which a prediction is being made.',
    value: 'target-semester',
  },
  {
    term: 'Tier',
    explanation:
      'A classification of students into groups based on either high school GPA and standardized test score or just high school GPA. The tiers range from 1 to 5 with 1 being high performing student.',
    value: 'tier',
  },
  {
    term: 'Transfer College Name',
    explanation: 'The college a student transferred to UWF from.',
    value: 'transfer-college-name',
  },
  {
    term: 'Transfer Hours',
    explanation:
      'Credit hours earned prior to enrolling at UWF as a transfer student.',
    value: 'transfer-hours',
  },
  {
    term: 'Transfer Students',
    explanation:
      'Students who join UWF after they earned college credits from other academic institutions.',
    value: 'transfer-students',
  },
  {
    term: 'Transfer FCS AA',
    explanation:
      'Students transferring from the Florida College System (FCS) with an associate in arts (AA) degree.',
    value: 'fcsaa',
  },
  {
    term: 'Transfer FCS AS',
    explanation:
      'Students transferring from the Florida College System (FCS) with an associate in science (AS) degree.',
    value: 'fcsas',
  },
  {
    term: 'Transfer Other',
    explanation: 'All students excluding Transfer FCS AA and Transfer FCS AS.',
    value: 'transfer-other',
  },
  {
    term: 'Unclassified',
    explanation: 'A student that is not categorized into a specific major.',
    value: 'unclassified',
  },
  {
    term: 'Semesters',
    explanation:
      'A breakdown of the academic calendar into three time periods. Fall [Aug-Dec], Spring [Jan-May], Summer [June-Aug]',
    value: 'semesters',
  },
  {
    term: 'Student ID (Student Identification)',
    explanation:
      'A unique number assigned to all UWF students and begins with a 970.',
    value: 'student-id',
  },
  {
    term: 'Student Type',
    explanation:
      'Classification of students as FTIC, Continuing, Transfers, and Graduates.',
    value: 'student-type',
  },
];
